import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFujitsuComponent } from './simple-icons-fujitsu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFujitsuComponent ],
    exports:      [ SimpleIconsFujitsuComponent ],
    bootstrap:    []
})
export class SimpleIconsFujitsuModule {}
